import script from "./FilterMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./FilterMenu.vue?vue&type=script&setup=true&lang=js"

import "./FilterMenu.vue?vue&type=style&index=0&id=23d7f670&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23d7f670"]])

export default __exports__